import { useEffect, useRef } from 'react';

/**
 * Cờ "component còn mounted" cho kết quả async. 🔴 Phải BẬT LẠI trong effect: React StrictMode (dev) chạy mount → cleanup → mount,
 * nếu chỉ gỡ ở cleanup thì cờ false vĩnh viễn và mọi kết quả bị bỏ (261010 P2a: trang kẹt mãi ở "Đang tải").
 */
export function useAliveRef(): React.MutableRefObject<boolean> {
  const alive = useRef(true);
  useEffect(() => {
    alive.current = true;
    return () => { alive.current = false; };
  }, []);
  return alive;
}
